import { defineComponent as _defineComponent } from 'vue'
import EditInstalledWorkflowConfiguration from '@/views/Installables/EditInstalledWorkflowConfiguration.vue';
import ExtensionCommunicationService from '@/utils/extension-communication-service';
import { Workflow } from '@ply-io/ply-front-shared-utilities';
import { onBeforeMount } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ExtensionEditInstalledWorkflowConfiguration',
  props: EditInstalledWorkflowConfiguration.props,
  setup(__props) {

const props = __props


onBeforeMount(() => {
	ExtensionCommunicationService.notifyExtensionPageCreated();
});
const close = (workflow: Workflow) => {
	ExtensionCommunicationService.announceWorkflow(workflow);
	ExtensionCommunicationService.closeWizard(window);
};

return { __sfc: true,props, close, EditInstalledWorkflowConfiguration }
}

})